import { render, staticRenderFns } from "./SDWAN.vue?vue&type=template&id=499b9fc6&scoped=true&"
import script from "./SDWAN.vue?vue&type=script&lang=js&"
export * from "./SDWAN.vue?vue&type=script&lang=js&"
import style0 from "./SDWAN.vue?vue&type=style&index=0&id=499b9fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499b9fc6",
  null
  
)

export default component.exports